import { canManageTemplatesByRole } from './role-model'

function parseBool(value, fallback = false) {
    if (value === undefined || value === null) return fallback
    if (typeof value === 'boolean') return value
    if (typeof value === 'number') return value === 1
    if (typeof value === 'string') {
        const v = value.trim().toLowerCase()
        if (['1', 'true', 'yes', 'y'].includes(v)) return true
        if (['0', 'false', 'no', 'n'].includes(v)) return false
    }
    return fallback
}

export function getTemplatePermissions(user) {
    const capabilities = user?.Capabilities

    // Legacy cached sessions may not include Capabilities — allow create, hide clone.
    if (capabilities == null) {
        return {
            canCreateTemplate: true,
            canCloneTemplate: false,
            canEditTemplate: true,
            canDeleteTemplate: true,
        }
    }

    // department role model: only Admins and Template managers manage templates (always true for other companies)
    const canCreateTemplate =
        parseBool(capabilities.CanCreateTemplate, false) &&
        canManageTemplatesByRole(user)

    return {
        canCreateTemplate,
        canCloneTemplate: canCreateTemplate,
        canEditTemplate: canCreateTemplate,
        canDeleteTemplate: canCreateTemplate,
    }
}

/** Path to the public template library for brand-new accounts, or null when not allowed. */
export function getEmptyAccountTemplateLibraryPath(user) {
    const { canCreateTemplate } = getTemplatePermissions(user)
    return canCreateTemplate ? '/app/templates/new-template-library' : null
}

export function getEmptyAccountFallbackPath(user) {
    return getEmptyAccountTemplateLibraryPath(user) || '/app/templates'
}

/** Post-login landing route when the user has no tasks and no templates yet. */
export function getPostLoginLandingPath(user, { hasTasks, hasTemplates }) {
    if (hasTasks || hasTemplates) {
        return '/app/task'
    }

    return getEmptyAccountTemplateLibraryPath(user) || '/app/templates'
}
